import Header from './components/header/Header';
import Home from './components/home/Home';
import Sectioned from './components/sectioned/Sectioned';
import Contact from './components/contact/Contact';
import Footer from './components/footer/Footer';
import Intruderdetection from './components/services/intruderdetection/Intruderdetection';
import Cctv from './components/services/cctv/cctv';
import Accesscontrol from './components/services/accesscontrol/Accesscontrol';
import Firealarm from './components/services/firealarm/Firealarm';

import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link
} from 'react-router-dom';
import './App.css';


function App() {
  return (
      <Router>
          <div className="App bg-light">
                <Header></Header>
                <Switch>
                    <Route path="/contact">
                        <Contact></Contact>
                    </Route>
                    <Route path="/intruderdetection">
                        <Intruderdetection></Intruderdetection>
                    </Route>
                    <Route path="/cctv">
                        <Cctv></Cctv>
                    </Route>
                    <Route path="/accesscontrol">
                        <Accesscontrol></Accesscontrol>
                    </Route>
                    <Route path="/firealarm">
                        <Firealarm></Firealarm>
                    </Route>
                    <Route path="/">
                        <Sectioned></Sectioned>
                    </Route>
                </Switch>
                <Footer></Footer>
            </div>
      </Router>
    
  );
}

export default App;
